import { render, staticRenderFns } from "./DisableNotificationBySmsAndEmail.vue?vue&type=template&id=547f22e9&"
import script from "./DisableNotificationBySmsAndEmail.vue?vue&type=script&lang=ts&"
export * from "./DisableNotificationBySmsAndEmail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports